#version 300 es
precision highp float;

in vec4 v_particle_color;
out vec4 outColor;
void main(){
    outColor=v_particle_color;
}
